import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

interface PrioritizeButtonsProps {
  rowReordering: {
    rowCount: number;
    priorityLoading?: boolean;
    disableSavePriority?: boolean;
    onSavePriority?: any;
    onCancelPriority?: any;
    onOpenPriority?: any;
    isPrioritizing?: boolean;
    changePriorityDisabledText?: string;
  };
}

export function PrioritizeButtons({ rowReordering }: PrioritizeButtonsProps) {
  const { t } = useTranslation();
  const {
    rowCount,
    priorityLoading,
    disableSavePriority,
    onSavePriority,
    onCancelPriority,
    onOpenPriority,
    isPrioritizing,
    changePriorityDisabledText,
  } = rowReordering || {};

  return onSavePriority && rowCount > 1 ? (
    isPrioritizing ? (
      <>
        <Button onClick={onCancelPriority} disabled={priorityLoading}>
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button
          type="primary"
          onClick={onSavePriority}
          loading={priorityLoading}
          disabled={disableSavePriority}
        >
          {t('settings.savePriority', 'Save Priority')}
        </Button>
      </>
    ) : (
      <Tooltip title={changePriorityDisabledText}>
        <Button onClick={onOpenPriority} disabled={changePriorityDisabledText !== undefined}>
          {t('settings.changePriority', 'Change Priority')}
        </Button>
      </Tooltip>
    )
  ) : null;
}
